import { render } from "./Auth.vue?vue&type=template&id=317d786b&lang=pug"
import script from "./Auth.vue?vue&type=script&lang=js"
export * from "./Auth.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lauouts/Auth.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "317d786b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('317d786b', __exports__)) {
    api.reload('317d786b', __exports__)
  }
  
  module.hot.accept("./Auth.vue?vue&type=template&id=317d786b&lang=pug", () => {
    api.rerender('317d786b', render)
  })

}


export default __exports__